import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import PaymentSuccess from "../../components/PaymentSuccess/PaymentSuccess";

const PaymentSuccessPage = () => {
  return (
    <div>
      <Header />
      <PaymentSuccess />
      <Footer />
    </div>
  );
};

export default PaymentSuccessPage;
